const configured = new WeakSet();
export function configureGaplessAxisSafety(axis) {
  if (configured.has(axis) || typeof axis._getIndexes !== 'function' || typeof axis._getDates !== 'function') return;
  configured.add(axis);
  const original = axis._getIndexes;
  const safeIndexes = function (...args) {
    // Data replacement can temporarily clear dates before series validation.
    // Do not let the library's default index 0 become an Invalid Date tick.
    if (!this._getDates().length) return [];
    const indexes = original.apply(this, args);
    const dates = this._getDates();
    return indexes.filter(index => Number.isInteger(index) && Number.isFinite(dates[index]));
  };
  axis._getIndexes = safeIndexes;
  axis.addDisposer({ dispose() { if (axis._getIndexes === safeIndexes) axis._getIndexes = original; } });
}
